import { RESTORE_FAILURE, RESTORE_REQUEST, RESTORE_SUCCESS } from '../../../../constants/ActionNameConstants';

export const restoreRequest = (data) => ({
  type: RESTORE_REQUEST,
  payload: data,
});

export const restoreSuccess = (request) => ({
  type: RESTORE_SUCCESS,
  payload: request,
});

export const restoreFailure = (error) => ({
  type: RESTORE_FAILURE,
  payload: error,
});
